import {Component, OnInit, OnDestroy,ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {Formatters} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';



@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.css']
})
export class ModuleComponent implements OnInit, OnDestroy {

  displayed = true;
  moduleName: string;
  description: string;
  totalData = 0;
  show: boolean;
  selected: number;
  respObject: any;

  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;
  displayData: any;
  isError = false;
  errorMessage: string;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  clientId: number;
  private baseFlag: any;
  private adminAuth: Subscription;

  private notifier: NotifierService;
  offset: number;
  dataLoaded:boolean;
  showSearch = true;
  isLoading = false;
  searchData: FormControl = new FormControl();
  moduleSelected: any;
  modules: any;
  des: string;
  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;

  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // console.log(item);
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            if (confirm('Are you sure?')) {
              const data = {
                name: item.MODULENAME, desc: item.MODDESCRIPTION, createdBy: this.messageService.getUserId(), id: item.id
              };
              this._rest.editModuleMst(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // console.log('data--Done');
                   this.notifier.notify('success', 'Module Edited successfully');
                } else {
                  // console.log('data--Not---Done');
                   this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                 this.notifier.notify('error', this.messageService.SERVER_ERROR);
              });
            }
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              // console.log(JSON.stringify(item));
              this._rest.deletePlatformModule({user_id: this.messageService.getUserId(), id: item.id}).subscribe((res) => {
                this.respObject = res;
                // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                  this.messageService.sendAfterDelete(item.id);
                  this.notifier.notify('success', 'Module Deleted successfully');
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
              });
            }
          }
          break;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      } else {
        this.add = false;
        this.del = false;
        this.view = false;
        this.edit = false;
      }
    });
  }

  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain Modules',
      openModalButton: 'Add Module',
      searchModalButton: 'Search',
      breadcrumb: 'Modules',
      folderName: 'All Modules',
      tabName: 'Modules'
    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'name', name: 'Module Name', field: 'MODULENAME', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'desc', name: 'Description', field: 'MODDESCRIPTION', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }

    this.searchData.valueChanges.subscribe(
      name => {
          this.isLoading = true;

          this._rest.searchAllModule( name, this.clientId).subscribe((res1) => {
              this.respObject = res1;
              this.isLoading = false;



              if (this.respObject.success) {
                  this.modules = this.respObject.details;
                  console.log("true"+ JSON.stringify(this.modules));


              } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
              }
          }, (err) => {
              this.isLoading = false;
              this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
      });
  }

  onPageLoad() {
    this.getTableData();
  }

  openModal(content) {
    if (!this.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.moduleName = '';
      this.description = '';
      // this.notifier.notify('success', 'Module added successfully');
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }

  }


  searchModal(){
  
      this.des = '';
      this.moduleSelected = '';
      // this.notifier.notify('success', 'Module added successfully');
      this.searchModalReference = this.modalService.open(this.scarch_content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });
  

  }

  getDetails() {
    for (let i = 0; i < this.modules.length; i++) {
        if (this.modules[i].MODULENAME === this.moduleSelected) {
          
            this.des = this.modules[i].MODDESCRIPTION;
        }
    }
}
search() {
  const data1 = [];
  for (let i = 0; i < this.modules.length; i++) {
      if (this.modules[i].MODULENAME === this.moduleSelected) {
        data1.push(this.modules[i]);
      }
  }
  this.page_no = 1;
  this.messageService.setTotalData(data1.length);
  this.messageService.setGridData(data1);
  this.searchModalReference.close();

}

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  save() {
    const data = {
      name: this.moduleName, desc: this.description, createdBy: this.messageService.getUserId()
    };
    if (!this.messageService.isBlankField(data)) {
      this._rest.addModule(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          this.isError = false;
          const id = this.respObject.moduleId;
          this.messageService.setRow({id: id, MODULENAME: this.moduleName, MODDESCRIPTION: this.description});
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.moduleName = '';
          this.description = '';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getSomeModules(offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  executeResponse(respObject, offset, paginationType) {
      if (respObject.success) {
        this.dataLoaded=true;
          if (offset === 0) {
              this.totalData = respObject.details.totalData[0].count;
              this.totalPage = respObject.details.totalPage;
              if (this.totalPage === 0) {
                  this.totalPage = 1;
              }
          }
          if (!this.isEmpty(respObject.details.dataObj)) {
              const data = respObject.details.dataObj;
              this.nextOffset = respObject.details.nextOffset;
              this.offset = respObject.details.nextOffset;
              this.previousOffset = respObject.details.previousOffset;
              this.messageService.setTotalData(this.totalData);
              this.messageService.setGridData(data);
              // ----------------------------------------------
              if (offset !== 0) {
                  const totalCount = this.totalData;
                  const divRes = totalCount / this.pageSize;
                  const remainder = totalCount % this.pageSize;
                  if (remainder === 0) {
                      this.totalPage = parseInt(String(divRes), 10);
                  } else {
                      this.totalPage = parseInt(String(divRes), 10) + 1;
                  }
              }
              // ------------------------------------------------
              if (paginationType === 'next') {
                  this.page_no = this.page_no + 1;
              } else if (paginationType === 'prev') {
                  this.page_no = this.page_no - 1;
              } else if (paginationType === '' && this.page_no === 0) {
                  this.page_no = this.page_no + 1;
              }
              if (this.totalData <= this.pageSize * this.page_no) {
                  this.nextOffset = 0;
              }
          } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
              this.nextOffset = 0;
          } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
              this.previousOffset = 0;
          } else if (paginationType === '' && this.page_no === 0) {
              this.page_no = this.page_no + 1;
          }
      } else {
          this.notifier.notify('error', respObject.errorMessage);
      }
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }
}

